import { render, staticRenderFns } from "./ResetUsername.vue?vue&type=template&id=dd26724a&scoped=true&"
import script from "./ResetUsername.vue?vue&type=script&lang=js&"
export * from "./ResetUsername.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd26724a",
  null
  
)

export default component.exports